import { MainLayout } from 'components';
import React, { useEffect, useState } from 'react';
import { Divider, Popover, Switch } from 'antd';
import pageTitleStore from 'store/pageTitleStore';
import { Col, Form, Input, Row, Space, Table, DatePicker, Select } from 'antd';
import Button from 'components/Button';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import useQueryParam from 'hooks/useQueryPrams';
import {
  AddIcon,
  EditIcon,
  EyeIcon,
  FilterGoldIcon,
  FilterIcon,
} from 'assets/svg';
import updateQueryStringParameter from 'utils/updateQueryStringParameter';
import { useHistory } from 'react-router-dom';
import { IGetUserQuery } from 'interface/user.interface';
import { HocChangePagination } from 'utils/HocChangePagination';
import CartApi from 'apis/CartApi';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { useMutation, useQuery } from 'react-query';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import PofTypeApi from 'apis/PofTypeApi';
import { MoreOutlined } from '@ant-design/icons';

export default function RecommendedListDetail() {
  const history = useHistory();
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const { RangePicker } = DatePicker;
  const [form] = useForm();
  const { Option } = Select;
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const params = {
    page: page,
    page_size: page_size,
    ...(formSubmitParams && formSubmitParams),
  };

  const { data: lstPofType } = useQuery(['getAll'], () =>
    PofTypeApi.getCartType()
  );

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(([_, value]) => value !== undefined)
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (key == 'release_date') {
        const ranges: any = filteredData[key];
        stringifiedData['release_from'] = String(ranges[0]);
        stringifiedData['release_to'] = String(ranges[1]);
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    setFormSubmitParams(stringifiedData);
  };

  const onGoToAddCart = () => {
    // history.push(`/declare-cart-info`);
  };

  useEffect(() => {
    setTitle('Danh mục khuyến nghị');
    setBreadcrumb([
      { title: <a href="">Thiết lập</a> },
      { title: <a href="/recommended-list">Danh mục khuyến nghị</a> },
    ]);
  }, [page, page_size, formSubmitParams]);

  const content = (
    <div>
      <p
        className="flex"
        onClick={() => history.push(`/recommended-list/edit/step1`)}
      >
        <EditIcon /> Chỉnh sửa
      </p>
    </div>
  );

  return (
    <MainLayout>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col
              className="text-xl font-bold mb-2"
              style={{ color: '#00538F' }}
              span={22}
            >
              Thông tin danh mục
            </Col>
            <Col
              className="flex justify-end"
              span={2}
              style={{ fontSize: '24px', color: '#00538F' }}
            >
              <Popover content={content} trigger="click">
                {/* <Button> */}
                <MoreOutlined />
                {/* </Button> */}
              </Popover>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Người quản lý
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.cart_type_name} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Trạng thái danh mục
                </Col>
                <Col className="" span={12}>
                  {/* : {formatDate(cart?.release_date)} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Đặt hàng theo Ni
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.description} */}
            </Col>
          </Row>

          <Col>
            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '8px',
              }}
              dashed
            />
          </Col>
          <div
            className="text-xl font-bold mb-2 mt-2"
            style={{ color: '#00538F' }}
          >
            Thông tin phê duyệt
          </div>
          <Row className="text-sm font-bold mb-1" style={{ color: '#00538F' }}>
            1.Phát hành danh mục
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Cấp phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={12}>
                  Thời gian phê duyệt
                </Col>
                <Col className="" span={6}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.email} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 1
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 2
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>

          <Row className="text-sm font-bold mb-1" style={{ color: '#00538F' }}>
            2.Chi nhánh đăng ký mẫu
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Cấp phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={12}>
                  Thời gian phê duyệt
                </Col>
                <Col className="" span={6}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.email} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 1
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 2
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>

          <Row className="text-sm font-bold mb-1" style={{ color: '#00538F' }}>
            3.Đăng ký giỏ hàng danh mục
          </Row>
          <Row className="text-sm font-bold mb-1">
            A. Chi nhánh (Chỉ phê duyệt đơn thuộc chi nhánh)
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Cấp phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={12}>
                  Thời gian phê duyệt
                </Col>
                <Col className="" span={6}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.email} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 1
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 2
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>

          <Row className="text-sm font-bold mb-1">B. Hội sở</Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Cấp phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={12}>
                  Thời gian phê duyệt
                </Col>
                <Col className="" span={6}>
                  {/* : {cart?.created_by} */}
                </Col>
              </Row>
            </Col>
            <Col className="" span={8}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại phê duyệt
                </Col>
                <Col className="" span={12}>
                  {/* : {cart?.email} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 1
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={3}>
              Người phê duyệt cấp 2
            </Col>
            <Col className="" span={20}>
              {/* : {cart?.department_name} */}
            </Col>
          </Row>
        </Content>
      </Form>
    </MainLayout>
  );
}
